import { render } from "./ActivityNewEventDialog.vue?vue&type=template&id=3c03a3e4"
import script from "./ActivityNewEventDialog.vue?vue&type=script&lang=js"
export * from "./ActivityNewEventDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__